"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryReportResponseToJSON = exports.OrderHistoryReportResponseFromJSONTyped = exports.OrderHistoryReportResponseFromJSON = exports.instanceOfOrderHistoryReportResponse = exports.OrderHistoryReportResponseCategoryLabelEnum = exports.OrderHistoryReportResponseCategoryEnum = void 0;
var runtime_1 = require("../runtime");
var OrderHistoryReportReleaseResponse_1 = require("./OrderHistoryReportReleaseResponse");
/**
 * @export
 */
exports.OrderHistoryReportResponseCategoryEnum = {
    AllPaperwork: 'all_paperwork',
    CarrierCouplesSummary: 'carrier_couples_summary',
    ClinicalSummaryReport: 'clinical_summary_report',
    CollaborationForm: 'collaboration_form',
    CreditCardAuthorizationForm: 'credit_card_authorization_form',
    DrugGeneSummary: 'drug_gene_summary',
    FamilyHistory: 'family_history',
    FfpeSpecimenRequestForm: 'ffpe_specimen_request_form',
    GeneticCounseling: 'genetic_counseling',
    GiaResultsTranscript: 'gia_results_transcript',
    GiaTranscript: 'gia_transcript',
    InsuranceCard: 'insurance_card',
    InsurancePaperwork: 'insurance_paperwork',
    Invoice: 'invoice',
    LetterOfMedicalNecessity: 'letter_of_medical_necessity',
    ManagementGuideline: 'management_guideline',
    MedicalRecords: 'medical_records',
    OnlineRequisitionForm: 'online_requisition_form',
    Other: 'other',
    PapFapApplication: 'pap_fap_application',
    PathologyReport: 'pathology_report',
    PatientMedicalRecord: 'patient_medical_record',
    PaymentReceipt: 'payment_receipt',
    PreliminaryReport: 'preliminary_report',
    PreviousResults: 'previous_results',
    Report: 'report',
    ReportCoverSheet: 'report_cover_sheet',
    SampleFailureLetter: 'sample_failure_letter',
    ScannedReqForm: 'scanned_req_form',
    SecInsuranceCard: 'sec_insurance_card',
    SupplementalReport: 'supplemental_report',
    Waiver: 'waiver',
    PayorSpecificPriorAuthorizationForm: 'payor_specific_prior_authorization_form',
    ClinicalNotesSupportingMedicalNecessityForGeneticTesting: 'clinical_notes_supporting_medical_necessity_for_genetic_testing'
};
/**
 * @export
 */
exports.OrderHistoryReportResponseCategoryLabelEnum = {
    GeneticCounselingDocumentation: 'Genetic counseling documentation',
    AllPaperwork: 'All Paperwork',
    CarrierCouplesSummary: 'Carrier Couples Summary',
    ClinicalSummaryReport: 'Clinical Summary Report',
    CollaborationForm: 'Collaboration Form',
    CreditCardAuthorizationForm: 'Credit Card Authorization Form',
    FamilyHistoryPedigree: 'Family History / Pedigree',
    FfpeSpecimenRequestForm: 'FFPE Specimen Request Form',
    GeneticCounselingDocsPostsToPatientPortal: 'Genetic Counseling docs (posts to patient portal)',
    GiaResultsTranscript: 'GIA Results Transcript',
    GiaTranscript: 'GIA Transcript',
    PrimaryInsuranceCard: 'Primary Insurance Card',
    InsurancePaperwork: 'Insurance Paperwork',
    Invoice: 'Invoice',
    LetterOfMedicalNecessity: 'Letter of Medical Necessity',
    ManagementGuidelinePostsToPortal: 'Management Guideline (posts to portal)',
    MedicalRecords: 'Medical Records',
    OnlineRequisitionForm: 'Online requisition form',
    Other: 'Other',
    PapApplication: 'PAP Application',
    PathologyReport: 'Pathology Report',
    PatientMedicalRecord: 'Patient Medical Record',
    PaymentReceipt: 'Payment Receipt',
    PgxDrugGeneTablesReport: 'PGx Drug-Gene Tables Report',
    PreliminaryReport: 'Preliminary Report',
    PreviousResults: 'Previous Results',
    ReportPostsToPortal: 'Report (posts to portal)',
    ReportCoverSheet: 'Report Cover Sheet',
    SampleFailureLetter: 'Sample Failure Letter',
    ScannedRequisitionForm: 'Scanned Requisition Form',
    SecondaryInsuranceCard: 'Secondary Insurance Card',
    Supplement: 'Supplement',
    WaiverNyEtc: 'Waiver (NY, etc)'
};
/**
 * Check if a given object implements the OrderHistoryReportResponse interface.
 */
function instanceOfOrderHistoryReportResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "categoryLabel" in value;
    return isInstance;
}
exports.instanceOfOrderHistoryReportResponse = instanceOfOrderHistoryReportResponse;
function OrderHistoryReportResponseFromJSON(json) {
    return OrderHistoryReportResponseFromJSONTyped(json, false);
}
exports.OrderHistoryReportResponseFromJSON = OrderHistoryReportResponseFromJSON;
function OrderHistoryReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': json['category'],
        'categoryLabel': json['categoryLabel'],
        'contentType': !(0, runtime_1.exists)(json, 'contentType') ? undefined : json['contentType'],
        'dateCreated': !(0, runtime_1.exists)(json, 'dateCreated') ? undefined : json['dateCreated'],
        'dateModified': !(0, runtime_1.exists)(json, 'dateModified') ? undefined : json['dateModified'],
        'downloadUri': !(0, runtime_1.exists)(json, 'downloadUri') ? undefined : json['downloadUri'],
        'isDownloaded': !(0, runtime_1.exists)(json, 'isDownloaded') ? undefined : json['isDownloaded'],
        'originalFilename': !(0, runtime_1.exists)(json, 'originalFilename') ? undefined : json['originalFilename'],
        'originalFilesize': !(0, runtime_1.exists)(json, 'originalFilesize') ? undefined : json['originalFilesize'],
        'positiveFinding': !(0, runtime_1.exists)(json, 'positiveFinding') ? undefined : json['positiveFinding'],
        'personalRisk': !(0, runtime_1.exists)(json, 'personalRisk') ? undefined : json['personalRisk'],
        'reportRelease': !(0, runtime_1.exists)(json, 'reportRelease') ? undefined : (0, OrderHistoryReportReleaseResponse_1.OrderHistoryReportReleaseResponseFromJSON)(json['reportRelease']),
        'requisition': !(0, runtime_1.exists)(json, 'requisition') ? undefined : json['requisition'],
        'resourceUri': !(0, runtime_1.exists)(json, 'resourceUri') ? undefined : json['resourceUri'],
        'uuid': !(0, runtime_1.exists)(json, 'uuid') ? undefined : json['uuid'],
    };
}
exports.OrderHistoryReportResponseFromJSONTyped = OrderHistoryReportResponseFromJSONTyped;
function OrderHistoryReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'categoryLabel': value.categoryLabel,
        'contentType': value.contentType,
        'dateCreated': value.dateCreated,
        'dateModified': value.dateModified,
        'downloadUri': value.downloadUri,
        'isDownloaded': value.isDownloaded,
        'originalFilename': value.originalFilename,
        'originalFilesize': value.originalFilesize,
        'positiveFinding': value.positiveFinding,
        'personalRisk': value.personalRisk,
        'reportRelease': (0, OrderHistoryReportReleaseResponse_1.OrderHistoryReportReleaseResponseToJSON)(value.reportRelease),
        'requisition': value.requisition,
        'resourceUri': value.resourceUri,
        'uuid': value.uuid,
    };
}
exports.OrderHistoryReportResponseToJSON = OrderHistoryReportResponseToJSON;
